module.exports = __webpack_public_path__ + "img/21.599d804f.jpg";